import type {ServerError} from '@yandex-delivery/core/utils/network'
import {getRumGlobal, logEvent} from '@yandex-delivery/modules/rum'
import type {ReactNode} from 'react'
import React, {Component} from 'react'

import type {ErrorScreenProps} from './ErrorScreen'
import {ErrorScreen} from './ErrorScreen'

type ErrorBoundaryProps = {
  children: ReactNode
  getScreenProps?: (error: ServerError) => ErrorScreenProps
  fallback?: ReactNode
}

type ErrorBoundaryState = {
  error?: ServerError
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = {}
  }

  static getDerivedStateFromError(error: ServerError): ErrorBoundaryState {
    return {error}
  }

  // https://a.yandex-team.ru/arcadia/taxi/frontend/services/newbiz-frontend/packages/modules/rum/error/ErrorBoundary.tsx?rev=r14924671#L56
  componentDidCatch(error: Ya.Rum.LoggableError, additional: React.ErrorInfo) {
    const {logError} = getRumGlobal() || {}
    const commonArgs: [Ya.Rum.LogErrorOptions, Ya.Rum.LoggableError] = [
      {additional, type: 'error-boundary'},
      error || new Error('MISSING_ERROR'),
    ]

    logError?.(...commonArgs)
    logEvent('error_boundary_shown')
  }

  render(): ReactNode {
    const {children, getScreenProps, fallback} = this.props

    if (this.state.error) {
      return fallback || <ErrorScreen {...getScreenProps?.(this.state.error)} />
    }

    return children
  }
}
